import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Opera } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteOpera, useOpera, useUpdateOpera } from '../../hooks/opere'
import OperaForm from '../../components/OperaForm'

export default function OperaEdit() {
  const { id } = useParams()
  const { data: opera } = useOpera(+id!)
  const deleteOpera = useDeleteOpera()
  const updateOpera = useUpdateOpera()
  const [modalRm, modalRmActions] = useModalTrigger<Opera>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/opere">Opere</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {opera!.titolo}
            </li>
          </ol>
        </nav>
        <div className="d-flex align-items-center">
          <button
            className="btn btn-danger"
            onClick={() => modalRmActions.open(opera)}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </div>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <OperaForm
          opera={opera}
          save={(opera) =>
            updateOpera.mutateAsync(opera).then(() =>
              toast.success('Opera ricerca alvato con successo!', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare l'opera {modalRm.value.titolo} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteOpera.isLoading}
            onClick={async () => {
              await deleteOpera.mutateAsync(modalRm.value!.id)
              navigate('/opere')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
